import { useContext } from "react";
import { Context } from "./context";

export const usePopupContainer = () => useContext(Context);
